import React, { useEffect, useState } from 'react';
import VerificationInput from '../VerificationInput';

const telegramUsernameValidation = (username: string): boolean => {
    const regex = /^(?!.*__)(?!.*_{2,})[a-zA-Z][a-zA-Z0-9_]{4,31}(?<!_)$/;
    return regex.test(username);
};

const StepTwo = ({ form, onChange, onNext, onPrev, onSendEmailCode, emailCodeSent, emailVerified, onVerifyEmailCode, loading, countdown, setCountdown, error }) => { 
  const [usernameError, setUsernameError] = useState(''); 

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [countdown, setCountdown]);

  const formatTime = seconds => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!telegramUsernameValidation(form.username)) {
        setUsernameError('نام کاربری نامعتبر است. باید با حرف شروع شود، حداقل ۵ کاراکتر و حداکثر ۳۲ کاراکتر باشد، فقط شامل حروف انگلیسی، اعداد و زیرخط باشد و با زیرخط تمام نشود.');
        return;
    }
    setUsernameError(''); 

    if(emailVerified && form.username) { 
        onNext();
    }
  }

  return (
    <form onSubmit={handleSubmit} autoComplete='off'>
      {(error || usernameError) && <div className='error-message'>{error || usernameError}</div>} 

      <div className='input-group'>
        <label>نام کاربری</label>
        <input type='text' name='username' value={form.username} onChange={(e) => { onChange(e); setUsernameError(''); }} required autoComplete='off' placeholder="یک نام کاربری به انگلیسی انتخاب کنید" style={{ direction: 'ltr', textAlign: 'right' }} /> 
      </div>
      <div className='input-group'>
        <label>ایمیل</label>
        <div className='phone-input-container'>
            <input type='email' name='email' value={form.email} onChange={onChange} required autoComplete='off' disabled={emailVerified || emailCodeSent} placeholder="ایمیل معتبر وارد کنید"/>
            {!emailVerified && (
            <button type='button' onClick={() => onSendEmailCode(form.email)} disabled={loading || countdown > 0} className='secondary-btn' style={{padding: '0.8rem 0.5rem'}}>
                {loading ? '...' : countdown > 0 ? `ارسال مجدد (${formatTime(countdown)})` : 'ارسال کد'}
            </button>
            )}
        </div>
      </div>

      {emailCodeSent && !emailVerified && (
        <div className='verification-code-section'>
          <label>کد تایید ایمیل را وارد کنید</label>
          <VerificationInput length={5} loading={loading} onComplete={onVerifyEmailCode} />
        </div>
      )}

      {emailVerified && <div className='success-message'>ایمیل با موفقیت تایید شد</div>}

      <div className='form-actions'>
        <button type='button' className='back-btn' onClick={onPrev}>قبلی</button>
        <button type='submit' className='next-btn' disabled={!emailVerified || !form.username || !!usernameError}>مرحله بعد</button> 
      </div>
    </form>
  );
};

export default StepTwo;